export default {
  init: process.env.BASE_URL + '/api/modules/appointment/index',
  submit: process.env.BASE_URL + '/api/modules/appointment/submit',
}